import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const loadState = (): { serviceProviderId: string; name?: string; } => {
    const savedState = localStorage.getItem('selectedServiceProvider');
    return savedState ? JSON.parse(savedState) as { serviceProviderId: string; name?: string; } : { serviceProviderId: '' };
};

const initialState: { serviceProviderId: string; name?: string; } = loadState();

const selectedServiceProviderSlice = createSlice({
    name: 'selectedServiceProvider',
    initialState,
    reducers: {
        setSelectedServiceProvider: (state, action: PayloadAction<{ serviceProviderId: string; name?: string; }>) => {
            localStorage.setItem('selectedServiceProvider', JSON.stringify(action.payload));
            return action.payload;
        },
        removeSelectedServiceProvider: (state) => {
            localStorage.removeItem('selectedServiceProvider');
            return { serviceProviderId: '' };
        },
    },
});

export const { setSelectedServiceProvider, removeSelectedServiceProvider } = selectedServiceProviderSlice.actions;
export default selectedServiceProviderSlice.reducer;
export const selectSelectedServiceProvider = (state: RootState) => state.selectedServiceProvider;